module.exports = __webpack_public_path__ + "img/78e2704.png";